import { createContext } from 'react'

import { createListingPickerStore } from '../store'

export const ListingPickerStoreContext = createContext<
  ReturnType<typeof createListingPickerStore> | undefined
>(undefined)
